import {sliderOpt} from 'src/app/shared/data';

export const introSlider = {
    ...sliderOpt,
    nav: false,
    loop: true,
};

export const banners = [
    {
        button_title: 'Explore Now',
        button_link: 'product/search/videos?searchText=Aerial%20drone%20shot&category=creative-videos&page=1',
        poster: 'assets/images/video/banner/poster_image1.jpg',
        video: 'assets/images/video/banner/video1.mp4',
        published: '1',
        subtitle: 'Capture breath-taking bird’s-eye views of cities, landscapes, and untouched nature with cinematic aerial footage.',
        title: 'Aerial & Drone Footage'
    },
    {
        button_title: 'Explore Now',
        button_link: 'product/search/videos?searchText=green%20screen%20&category=creative-videos&page=1',
        poster: 'assets/images/video/banner/poster_image2.jpg',
        video: 'assets/images/video/banner/video2.mp4',
        published: '1',
        subtitle: 'Unlock endless creativity with premium green screen and isolated elements for versatile productions.',
        title: 'Green Screen & Isolated Backgrounds'
    },
    {
        button_title: 'Explore Now',
        button_link: 'product/search/videos?searchText=360-Degree%20and%20VR%20&category=creative-videos&page=1',
        poster: 'assets/images/video/banner/poster_image3.jpg',
        video: 'assets/images/video/banner/video3.mp4',
        published: '1',
        subtitle: 'Transport audiences into immersive worlds with panoramic VR footage of places, events, and products.',
        title: '360-Degree & VR Videos'
    },
    {
        button_title: 'Explore Now',
        button_link: 'product/search/videos?searchText=AI%20Technology&category=creative-videos&page=1',
        poster: 'assets/images/video/banner/poster_image4.png',
        video: 'assets/images/video/banner/video4.mp4',
        published: '1',
        subtitle: 'Explore futuristic visuals of robotics, automation & innovation through cutting-edge AI technology stock videos.',
        title: 'AI Technology'
    },
    {
        button_title: 'Explore Now',
        button_link: 'product/search/videos?searchText=motion%20graphics&category=creative-videos&page=1',
        poster: 'assets/images/video/banner/poster_image5.png',
        video: 'assets/images/video/banner/video5.mp4',
        published: '1',
        subtitle: 'Elevate your projects with bold motion graphics, creative animations, dynamic visual effects, and stunning transitions in HD & 4K.',
        title: 'Motion Graphics'
    },

    {
        button_title: 'Explore Now',
        button_link: 'product/search/videos?searchText=Sports&category=creative-videos&page=1',
        poster: 'assets/images/video/banner/poster_image7.png',
        video: 'assets/images/video/banner/video7.mp4',
        published: '1',
        subtitle: 'Feel the adrenaline with action-packed sports videos spanning stadium moments, fitness, and outdoor challenges.',
        title: 'Sports'
    },
    {
        button_title: 'Explore Now',
        button_link: 'product/search/videos?searchText=people%20and%20lifestyle&category=creative-videos&page=1',
        poster: 'assets/images/video/banner/poster_image6.png',
        video: 'assets/images/video/banner/video6.mp4',
        published: '1',
        subtitle: 'Celebrate authentic human stories with stock footage capturing cultures, traditions, and modern lifestyles.',
        title: 'People & Lifestyle'
    },
    {
        button_title: 'Explore Now',
        button_link: 'product/search/videos?searchText=Slow%20Mo%20&category=creative-videos&page=1',
        poster: 'assets/images/video/banner/poster_image8.png',
        video: 'assets/images/video/banner/video8.mp4',
        published: '1',
        subtitle: 'Add cinematic drama with slow-motion footage that magnifies every detail, movement, and emotion.',
        title: 'Slow Motion'
    },
    {
        button_title: 'Explore Now',
        button_link: 'product/search/videos?searchText=animation%20video&category=creative-videos&page=1',
        poster: 'assets/images/video/banner/poster_image9.png',
        video: 'assets/images/video/banner/video9.mp4',
        published: '1',
        subtitle: 'A creative library of 2D and 3D animations, perfect for branding, education, entertainment, and commercial use.',
        title: 'Animation'
    }
];
